import request from '@/utils/request'

/**
 * 获取服务实现列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listServiceImpls(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceImpl.listServiceImpls',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加服务实现
 * @param {Object} data 服务实现数据
 * @returns {Promise} Promise对象
 */
export function saveServiceImpl(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceImpl.saveServiceImpl',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改服务实现
 * @param {Object} data 服务实现数据
 * @returns {Promise} Promise对象
 */
export function updateServiceImpl(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceImpl.updateServiceImpl',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务实现
 * @param {Object} data 服务实现数据
 * @returns {Promise} Promise对象
 */
export function deleteServiceImpl(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/serviceImpl.deleteServiceImpl',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}